export default __webpack_public_path__ + "static/media/img.4cb6e79a.jpg";